// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_pallet_management_ui_styles" + "." + "bb9477d0" + ".chunk.css";
};